// portals
export const paths = {
  dashboard: '/dashboard',

  addBiologicalInformation: "/bio-info/add",
  viewBiologicalInformation: "/bio-info/view/:id",
  editBiologicalInformation: "/bio-info/edit/:id",
  viewAllBiologicalInformation: "/bio-info",

  addCouncil: "/council/add",
  viewCouncil: "/council",
  editCouncil: "/council/edit/:id",

  addDebate: "/debate/add",

  addFaq: "/faq/add",
  editFaq: "/faq/edit/:id",
  viewFaq: "/faq/view/:id",
  viewAllFaq: "/faq",

  addGallery: "/gallery/add",
  viewAllGallery: "/gallery/all",
  viewGallery: "/gallery",
  editGallery: "/gallery/edit/:id",
  viewGalleryImage: "/gallery/view/:id",

  addHouse: "/house/add",
  viewHouse: "/house",
  editHouse: "/house/edit/:id",

  editInterest: "/interest-request/interest/edit/:id",
  editRequest: "/interest-request/request/edit/:id",
  viewInterest: "/interest-request/interest/view/:id",
  viewRequest: "/interest-request/request/view/:id",
  viewInterestRequest: "/interest-request",

  viewAllLegislativeAssembly: "/legislative-assembly",
  addLegislativeAssembly: "/legislative-assembly/add",
  viewLegislativeAssembly: "/legislative-assembly/view/:id",
  editLegislativeAssembly: "/legislative-assembly/edit/:id",

  viewAllLegislativeCouncil: "/legislative-council",
  addLegislativeCouncil: "/legislative-council/add",
  viewLegislativeCouncil: "/legislative-council/view/:id",
  editLegislativeCouncil: "/legislative-council/edit/:id",

  viewAllLegislativeMember: "/legislative-member",
  viewLegislativeMember: "/legislative-member/view/:id",
  addLegislativeMember: "/legislative-member/add",
  editLegislativeMember: "/legislative-member/edit/:id",
  viewMemberProfile: "/legislative-member/profile/view/:id",

  addLibrary: "/library/add",
  viewLibrary: "/library/view/:id",
  editLibrary: "/library/edit/:id",
  viewAllLibrary: "/library",

  addLibraryDoc: "/library-doc/add",
  editLibraryDoc: "/library-doc/edit/:id",
  viewAllLibraryDoc: "/library-doc",

  addMantriMandal: "/mantri-mandal/add",
  viewAllMantriMandal: "/mantri-mandal",
  viewMantriMandal: "/mantri-mandal/view/:id",
  editMantriMandal: "/mantri-mandal/edit/:id",

  addRajyapal: "/rajyapal/add",
  editRajyapal: "/rajyapal/edit/:id",
  viewRajyapal: "/rajyapal/view/:id",
  viewAllRajyapal: "/rajyapal",

  addSessionCalendar: "/session-calendar/add",
  editSessionCalendar: "/session-calendar/edit/:id",
  viewSessionCalendar: "/session-calendar/view/:id",
  viewAllSessionCalendar: "/session-calendar",

  viewAllVidhanMandal: "/vidhan-mandal",
  addVidhanMandal: "/vidhan-mandal/add",
  viewVidhanMandal: "/vidhan-mandal/view/:id",
  editVidhanMandal: "/vidhan-mandal/edit/:id",

  // masters

  addAssembly: "/assembly/add",
  viewAssembly: "/assembly",
  editAssembly: "/assembly/edit/:id",

  addBranch: "/branch/add",
  viewBranch: "/branch",
  editBranch: "/branch/edit/:id",

  addCommittee: "/committee/add",
  viewCommittee: "/committee",
  editCommittee: "/committee/edit/:id",

  addConstituency: "/constituency/add",
  viewConstituency: "/constituency",
  editConstituency: "/constituency/edit/:id",

  addConstituencyType: "/constituency-type/add",
  viewConstituencyType: "/constituency-type",
  editConstituencyType: "/constituency-type/edit/:id",

  addDepartment: "/department/add",
  viewDepartment: "/department",
  editDepartment: "/department/edit/:id",

  addDesignation: "/designation/add",
  editDesignation: "/designation/edit/:id",
  viewDesignation: "/designation",

  addDistrict: "/district/add",
  viewDistrict: "/district",
  editDistrict: "/district/edit/:id",

  addGender: "/gender/add",
  viewGender: "/gender",
  editGender: "/gender/edit/:id",

  addLegislativePosition: "/legislative-position/add",
  editLegislativePosition: "/legislative-position/edit/:id",
  viewLegislativePosition: "/legislative-position",

  addMinistry: "/ministry/add",
  viewMinistry: "/ministry",
  editMinistry: "/ministry/edit/:id",

  addMemberName: "/member-name/add",
  editMemberName: "/member-name/edit/:id",
  viewMemberName: "/member-name",

  addNavigation: "/navigation/add",
  viewNavigation: "/navigation",
  editNavigation: "/navigation/edit/:id",

  addPoliticalParty: "/political-party/add",
  viewPoliticalParty: "/political-party",
  editPoliticalParty: "/political-party/edit/:id",

  addPresidingOfficer: "/presiding-officer/add",
  editPresidingOfficer: "/presiding-officer/edit/:id",
  viewPresidingOfficer: "/presiding-officer",

  addSessionField: "/session-field/add",
  editSessionField: "/session-field/edit/:id",
  viewSessionField: "/session-field",

  // home
  viewAudit: "/audit",
  viewUserAudit: "/audit/user/edit/:id",
  viewAllUserAudit: "/audit/user",

  addContact: "/contact/add",
  editContact: "/contact/edit/:id",
  viewContact: "/contact",

  viewFeedback: "/feedback/:id",
  editFeedback: "/feedback/edit/:id",
  viewAllFeedback: "/feedback",

  addFileManager: "/file-manager/add",
  editFileManager: "/file-manager/edit/:id",
  viewFileManager: "/file-manager",

  editHelpdesk: "/helpdesk/edit/:id",
  viewAllHelpdesk: "/helpdesk",
  viewHelpdesk: "/helpdesk",

  addPortalBranch: "/portal-branch/add",
  editPortalBranch: "/portal-branch/edit/:id",
  viewPortalBranch: "/portal-branch",

  addPortalDepartment: "/portal-department/add",
  editPortalDepartment: "/portal-department/edit/:id",
  viewPortalDepartment: "/portal-department",

  addPortalUser: "/portal-user/add",
  editPortalUser: "/portal-user/edit/:id",
  viewPortalUser: "/portal-user",
  blockPortalUser: "/portal-user/block/:id",
  resetPortalUser: "/portal-user/reset/:id",
  uploadPortalUser: "/portal-user/upload/:id",

  addSeo: "/seo/add",
  editSeo: "/seo/edit/:id",
  viewSeo: "/seo",

  addTask: "/task/add",
  editTask: "/task/edit/:id",
  viewTask: "/task",

  userRole: "/user-role",
  editRole: "/user-role/edit/:id",

  viewAllUserDocument: "/user-document",
  viewUserDocument: "/user-document/edit/:id",
  addUserDocument: "/user-document/add",
  editUserDocument: "/user-document/edit/:id",

  addWorkflow: "/workflow/add",
  editWorkflow: "/workflow/edit/:id",
  viewWorkflow: "/workflow/view/:id",
  viewAllWorkflow: "/workflow",
  viewWorkflowHistory: "/workflow/history",
  viewArchive: "/archive",

  // pendings
  viewWorkflowBiologicalInformation: "/workflow/bio-info/:id",
  viewWorkflowContactUs: "/workflow/contact/:id",
  viewWorkflowFaq: "/workflow/faq/:id",
  viewWorkflowGallery: "/workflow/gallery/:id",
  viewWorkflowGalleryImage: "/workflow/gallery/image/:id",
  viewWorkflowInterestRequest: "/workflow/interest-request/:id",
  viewWorkflowLegislativeAssembly: "/workflow/legislative-assembly/:id",
  viewWorkflowLegislativeCouncil: "/workflow/legislative-council/:id",
  viewWorkflowLibrary: "/workflow/library/:id",
  viewWorkflowMantriMandal: "/workflow/mantri-mandal/:id",
  viewWorkflowMemberProfile: "/workflow/member/:id",
  viewWorkflowRajyapal: "/workflow/rajyapal/:id",
  viewWorkflowSessionCalendar: "/workflow/session-calendar/:id",
  viewWorkflowVidhanMandal: "/workflow/vidhan-mandal/:id",
};
